export default class AudioPlayer{
    constructor(file){
        this.audioElement = new Audio(file);
        this.audioElement.addEventListener("canplaythrough", e => {
            this.isReady = true;
        });
    }

    play(time){
        this.audioElement.play();
        this.audioElement.currentTime = time;
    }

    time(){
        return this.audioElement.currentTime;
    }
}